import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { EditorConfiguration, Editor } from 'codemirror';
import _ from 'underscore';

@Component({
    selector: 'agpr-accessible-code-mirror',
    templateUrl: './accessible-code-mirror.component.html',
    standalone: false
})
/**
 * For CodeMirror SR a11y.
 * Can likely remove when ngx-codemirror upgrades to CodeMirror 6 as this version fixes most of the accessiblity issues.
 */
export class AccessibleCodeMirrorComponent implements AfterViewInit {
    @Input() value: string;
    @Input() config: EditorConfiguration;
    @Input() codeMirrorStyleClass: string;

    @Output() htmlChange: EventEmitter<string> = new EventEmitter();

    @ViewChild('codeEditor') private cmEditorRef: any;

    private cmEditor: Editor;
    textContent: string;
    currentLine: number;
    lineChanged: boolean = true;
    isSelection: boolean = false;

    debouncedCursorMoved = _.debounce(() => this.cursorMoved(), 200);

    ngAfterViewInit(): void {
        this.cmEditor = this.cmEditorRef.codeMirror;
        // Hiding the textarea and display content from the SR
        // Announces 'blank' before the live region content
        const cmInput = this.cmEditor?.getInputField();
        if (cmInput) {
            cmInput.setAttribute('aria-hidden', 'true');
        }
        // Announces entire code block on hover starting from the beginning every time the mouse is moved
        const cmDisplay = document.querySelector('.CodeMirror-scroll');
        if (cmDisplay) {
            cmDisplay.setAttribute('aria-hidden', 'true');
        }
    }

    /**
     * Sets the content of the live region based on selection or cursor position.
     * If there is a selection the entire selection is added to the live region.
     * If cursor is at beginning or end of line entire line is added.
     * If cursor is anywhere else the current character is added. Current character is determined by the sticky property of the cursor position.
     */
    private cursorMoved() {
        if (this.cmEditor) {
            if (!this.cmEditor.somethingSelected()) {
                const cursorPosition = this.cmEditor.getCursor();
                this.lineChanged = cursorPosition.line !== this.currentLine;
                if (this.lineChanged) {
                    this.currentLine = cursorPosition.line;
                }
                this.isSelection = false;
                const currentCharIndex = cursorPosition.ch;
                const lineContent: string = this.cmEditor.getLine(this.currentLine);
                if (currentCharIndex > 0 && currentCharIndex < lineContent.length) {
                    this.textContent = lineContent.charAt(cursorPosition.sticky === 'before' ? currentCharIndex - 1 : currentCharIndex);
                    if (this.textContent.trim().length === 0) {
                        this.textContent = 'space';
                    }
                } else {
                    this.textContent = lineContent;
                }
                if (this.textContent.trim().length === 0) {
                    this.textContent = 'blank';
                }
            } else {
                this.lineChanged = false;
                this.isSelection = true;
                this.textContent = this.cmEditor.getSelection();
            }
        }
    }
}
